var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2048v2048H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M255.999 255.999h1536v1536h-1536z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "m1303.19 263.999 328.759 329.158h-269.982c-32.328 0-58.776-26.448-58.776-58.776V263.999z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc80",
    d: "M454.851 263.999h848.395v268.747c0 33.228 27.184 60.411 60.411 60.411h268.344V1408c0 22-17.999 40-40 40H454.852c-22 0-39.998-18-39.998-40V304c0-22 17.999-40 39.999-40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    fillRule: "nonzero",
    d: "M671.999 763.342H1408v64.002H671.999zM671.999 987.337H1408v64.003H671.999z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M337.396 1226.19h1373.21c22.375 0 42.735 9.234 57.51 24.108 14.738 14.835 23.887 35.238 23.887 57.618v394.353c0 22.381-9.15 42.782-23.887 57.618-14.777 14.874-35.136 24.109-57.51 24.109H337.396c-22.373 0-42.735-9.235-57.512-24.109-14.736-14.833-23.885-35.234-23.885-57.618v-394.353c0-22.381 9.149-42.783 23.885-57.618 14.775-14.874 35.137-24.108 57.512-24.108z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M651.876 1684.05v-65.166l188-232.167H673.125v-60.584h262.001v56.168l-196.083 241.416h203.666v60.333H651.876zm334.25 0v-357.917h72.25v357.917h-72.25zm141.167 0v-357.917h115.916c43.917 0 72.583 1.833 85.917 5.417 20.5 5.333 37.75 17 51.583 35 13.834 18 20.75 41.25 20.75 69.667 0 22-4 40.5-12 55.416-8 15-18.083 26.75-30.416 35.334-12.25 8.5-24.75 14.166-37.417 16.917-17.25 3.415-42.25 5.166-75 5.166h-47.084v135h-72.249zm72.25-297.333v101.5h39.5c28.5 0 47.583-1.834 57.167-5.584 9.583-3.75 17.083-9.584 22.582-17.583 5.417-8 8.168-17.25 8.168-27.833 0-13-3.834-23.75-11.5-32.25-7.583-8.417-17.333-13.75-29-15.834-8.667-1.667-26.001-2.417-52-2.417h-34.918z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.3bcdd41912aed3e69693c842289165f2.svg";
export { ForwardRef as ReactComponent };